import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ILinkbox } from './../models/linkbox.model';

@Injectable({
  providedIn: 'root'
})
export class FormTemplateService {

  constructor(private http: HttpClient) {
  }

  async getFormTemplateAsync(formTemplateName) {
    var template = await this.http.get<ILinkbox>("assets/formtemplates/" + formTemplateName + ".json").toPromise();
    return template;
  }

  getFormTemplate(formTemplateName) {
    var template = this.http.get<ILinkbox>("assets/formtemplates/" + formTemplateName + ".json");
    return template;
  }
}
